// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"4fac1213","453":"c053c38e","635":"3d5dac35","821":"81f44ce1","925":"5a4acb91","931":"dd09bee3"}[chunkId] + ".chunk.js";
};